import {AfterViewInit, Component} from "@angular/core";
import {noop} from "rxjs";
import {CookiePolicyModalService} from "@app/shared/components/cookie-policy-modal/cookie-policy-modal.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements AfterViewInit {
  constructor(private cookiePolicyModalService: CookiePolicyModalService) {}

  ngAfterViewInit(): void {
    if (!this.cookiePolicyModalService.isCookieAccessChecked()) {
      this.cookiePolicyModalService.startDialog$().subscribe(noop);
    }
  }
}
